import { render, staticRenderFns } from "./Reason.vue?vue&type=template&id=756ac419&scoped=true&"
import script from "./Reason.vue?vue&type=script&lang=ts&"
export * from "./Reason.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756ac419",
  null
  
)

export default component.exports